const moElectricBlue = "#00a7e2"
const moElectricBlueMed = "#74c0eb"
const moElectricBlueLight = "#b4d9f3"

const gloLightBlue = "#00b7f1"
const gloLightBlueMed = "#6acff6"
const gloLightBlueLight = "#b9e5fb"

const moCrispOrange = "#f37121"
const moCrispOrangeMed = "#f6895b"
const moCrispOrangeLight = "#fcd0b8"

const gloLightOrange = "#f9a01b"
const gloLightOrangeMed = "#febe10"
const gloLightOrangeLight = "#ffe6b4"

const moJungleTeal = "#008560"
const moJungleTealMed = "#64aa91"
const moJungleTealLight = "#a0c9ba"

const gloLightTeal = "#36b0a7"
const gloLightTealMed = "#65bbb5"
const gloLightTealLight = "#a1d2cf"

const moFlowerRed = "#ee283b"
const moFlowerRedMed = "#f26d61"
const moFlowerRedLight = "#fbc7ba"

const gloLightRed = "#f0532d"
const gloLightRedMed = "rgb(245, 130, 89)"
const gloLightRedLight = "rgb(251, 196, 170)"

const moDarkPurple = "#601872"
const moDarkPurpleMed = "#7b4c8c"
const moDarkPurpleLight = "#9471a4"

const gloMagenta = "#ec008c"
const gloMagentaMed = "rgb(226, 131,174)"
const gloMagentaLight = "#f4d5e3"

const moClassicBlack = "#001010"
const moClassicBlackMedGrey = "#808285"
const moClassicBlackLightGrey = "rgb(209,211,212)"

const gloPureWhite = "rgb(255,255,255)"
const gloPureWhiteMed = "#d9f1fd"
const gloPureWhiteLight = "#f1fafe"

const gradient1 = `linear-gradient(to right, ${moElectricBlue}, ${gloLightBlueMed})`
const gradient2 = `linear-gradient(to right, ${moCrispOrange}, ${gloLightOrange})`
const gradient3 = `linear-gradient(to right, ${moFlowerRed}, ${gloLightRed})`
const gradient4 = `linear-gradient(to right, ${moDarkPurple}, ${gloMagenta})`
const gradient5 = `linear-gradient(to right, ${moJungleTeal}, ${gloLightTeal})`
const gradient6 = `linear-gradient(to right, ${gloLightOrange}, ${gloLightOrangeMed})`
const gradientAdd = `linear-gradient(to right, ${gloMagentaMed}, ${moDarkPurpleMed})`

export default {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
  colors: {
    background: gradient1,
    interactiveBackground: moClassicBlack,
    navigationButton: moClassicBlack,
    landingButton: moClassicBlack,
    primaryButton: moClassicBlack,
    secondaryButton: moClassicBlackMedGrey,
    callToAction: moCrispOrange,
    tabSelected: moCrispOrange,
    activityButtonBackground: moClassicBlack,
    activityButton1: gradient3,
    activityButton2: gradient4,
    activityButton3: gradient5,
    activityButton4: gradient6,
    success: moCrispOrange,
    black: moClassicBlack,
    secondaryBlack: "#161616",
    white: gloPureWhite,
    grey: moClassicBlackMedGrey,
    darkgrey: "#303030",
    sign: gradient2,
    modalBackground: gradient1,
    modalHeader: gloPureWhite,
    modalFooter: gloPureWhite,
    modalBody: gloPureWhite,
    modalText: moClassicBlack,
    inputText: moClassicBlack,
    inputBackground: "rgb(248, 248, 248)",
    inputBorder: "rgb(166, 166, 166)",
    inputPlaceholder: "rgb(166, 166, 166)",
    selectedInput: moElectricBlue,
    text: gloPureWhite,
    danger: "red",
    placeOrder: moJungleTeal
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256],
  fonts: {
    primary: "Neutra",
    secondary: "Nexa",
    tertiary: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  shadows: {
    smallPrimary: "0 1px 2px rgba(0, 109, 191, 0.9)",
    largePrimary: "10px 10px 48px -9px rgba(0,109,191,1)",
    smallSecondary: `0 1px 2px ${moClassicBlackMedGrey}`,
    largeSecondary: `10px 10px 48px -9px ${moClassicBlackMedGrey}`
  },
  breakpoints: [480, 736, 980, 1280, 1690]
}
